export class TenderNotFoundError extends Error {
}